import { StateParams, StateService } from "@uirouter/angularjs";
import { IOnInit } from "angular";

import {
  IFieldArray,
  IFieldRuntimeObject,
  ITemplateScope,
} from "AngularFormly";
import { FormViewController } from "../../../../../app/records/forms/formView/controller";
import { set } from "lodash";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../../app/records/server/serverUtility";

import {
  FormViewService,
  vsName as FormViewServiceName,
} from "../../../../../app/records/forms/formView/service";
import fieldHelpers from "../../../../../app/ui-formly/fieldHelpers";

import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../../../app/records/forms/formly/fieldConfigurationHelpers";
import {
  vsServiceName as LookupModalServiceName,
  LookupModalService,
} from "../../../../records/lookup/lookupModal";
import { LookupManagementService } from "../../../../records/lookup/lookupManagement";
import { vsLookupManagementServiceName as LookupManagementServiceName } from "../../../configs/lookupManagement";

export class ProcessTemplateEditController implements IOnInit {
  static $inject = [
    FormViewServiceName,
    "$state",
    FieldConfigurationHelperServiceName,
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
    LookupModalServiceName,
    LookupManagementServiceName,
    "$scope",
    "$timeout",
  ];
  model: any;
  formFields!: IFieldArray;
  template!: any;
  templateId: string = "";
  editor: any;
  selectedPlaceholder: string = "";
  tinyMceOptions: any;
  isDisabled: boolean = false;

  constructor(
    private readonly formViewService: FormViewService,
    private readonly $state: StateService,
    private readonly fieldConfigurationHelperService: FieldConfigurationHelperService,
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility,
    private readonly lookupModalService: LookupModalService,
    private readonly lookupManagementService: LookupManagementService,
    private readonly $scope: ng.IScope,
    private readonly $timeout: ng.ITimeoutService
  ) {}
  enableEditor(): void {
    this.isDisabled = false;
  }
  private initializeTinyMCE(): void {
    this.tinyMceOptions = {
      selector: "#tinyMCEContainer",
      content_css: ["writer", "/content.css"],
      inline: false,
      plugins: "importcss",
      toolbar:
        "insertplaceholder | undo redo | formatselect | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat",
      setup: (editor: any) => {
        this.editor = editor;

        editor.on("keyup", () => {
          this.$scope.$apply(() => {
            //this.model.MailBody = editor.getContent();
          });
        });
        editor.ui.registry.addButton("insertplaceholder", {
          icon: "placeholder",
          tooltip: "Insert Placeholder",
          onAction: () => {
            this.openPlaceholderDialog();
          },
        });
      },
      theme: "silver",
      menubar: "file edit view insert format table",
    };
  }
  openPlaceholderDialog(): void {
    const placeholderDropdown = `
      <select id="placeholderDropdown" [(ngModel)]="selectedPlaceholder">
        <option value="">Select a placeholder</option>
        <option value="FirstName">First Name</option>
        <option value="LastName">Last Name</option>
        <option value="Email">Email</option>
      </select>
    `;
    const popup = this.editor.windowManager.open({
      title: "Insert Placeholder",
      body: {
        type: "panel",
        items: [
          {
            type: "htmlpanel",
            html: placeholderDropdown,
          },
        ],
      },
      buttons: [
        {
          type: "cancel",
          text: "Cancel",
        },
        {
          type: "submit",
          text: "Insert",
          primary: true,
          name: "submit",
        },
      ],
      onSubmit: () => {
        this.insertPlaceholder();
        popup.close();
      },
    });
  }

  insertPlaceholder(): void {
    const selectedPlaceholder = (
      document.getElementById("placeholderDropdown") as HTMLSelectElement
    ).value;
    if (selectedPlaceholder && this.editor) {
      this.editor.insertContent("{{" + selectedPlaceholder + "}}");
    }
  }

  private initializeFormFields() {
    const that = this;

    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.simpleStringField({
            key: "Type",
            name: "Type",
            label: "Process Type",
          }),
          fieldHelpers.simpleStringField({
            key: "Action",
            name: "Action",
            label: "Process Action",
          }),
          fieldHelpers.simpleStringField({
            key: "MailSubject",
            name: "MailSubject",
            label: "Mail Subject",
          }),
        ],
        3
      ),
    ];
  }

  $onInit(): void {
    this.templateId = this.$stateParams["templateId"];
    this.model = this.template[0] ? this.template[0] : {};
    this.model.Id = this.template[0] ? this.template[0].Id : null;

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = "../../../../../../css/signature.css";
    document.head.appendChild(link);

    this.initializeTinyMCE();
    this.initializeFormFields();
  }

  async submit(formViewController: FormViewController): Promise<void> {
    if (this.model.Id == null) {
      await this.formViewService.submitForm({
        url: `/api/process/template`,
        formObject: this.model,
        formViewController,
        method: "POST",
      });
    } else {
      await this.formViewService.submitForm({
        url: `/api/process/template/${this.templateId}`,
        formObject: this.model,
        formViewController,
        method: "PUT",
      });
    }
    await this.$state.go("main.contract.process.template", undefined, {
      reload: true,
    });
  }

  async cancel() {
    await this.$state.go("main.contract.process.template", undefined, {
      reload: true,
    });
  }

  private nullWhenFalse(watch: string) {
    return {
      expression: watch,
      listener: (
        field: IFieldRuntimeObject,
        newValue: any,
        _: any,
        scope: ITemplateScope
      ) => {
        if (!newValue) {
          const path = field.key ?? "";
          set(scope.model ?? {}, path, undefined);
        }
      },
    };
  }
}
